module.exports = __webpack_public_path__ + "img/covid-light.ad1222f5.svg";